/**
 * Design tokens extracted from the Figma file "Freemium Plan"
 * (key B4Og6IzjWFmnFZ1fRdMESd — desktop 2006:3964, mobile 2004:1716,
 * language 2006:3442) via the REST API node JSON. Every value here is the
 * exact Figma value — do not eyeball-adjust; re-extract instead.
 */

export const COLORS = {
  primary: "#5B2FF9",
  primaryHover: "#472FCC",
  p700: "#342399",
  p200: "#CFC7FF",
  p100: "#E6E1FF",
  text: "#0C0A1A",
  muted: "#6B6580",
  muted2: "#A09BB8",
  placeholder: "#757575",
  surface: "#F2F0FA",
  /** Screens sit on plain white per the Figma frames (no tinted page bg). */
  pageBg: "#FFFFFF",
  /** Language-selection panel bg (edge frame). */
  panelBg: "#F7F6FB",
  border: "rgba(0,0,0,0.07)",
  error: "#DC2626",
  errorBg: "#FEE2E2",
  success: "#15803D",
  liveDot: "#22C55E",
  successLight: "#4ADE80",
  gray: "#374151",
  grayLight: "#F3F4F6",
} as const;

export const FONT = {
  /** App/Arabic UI font — already loaded globally by the app. */
  arabic: "'Tajawal', sans-serif",
  /** Latin accents: URLs, step chips, numbers (per Figma). Loaded by the wizard shell. */
  latin: "'DM Sans', 'Tajawal', sans-serif",
} as const;

/** Text roles — family / weight / size / line-height exactly per Figma. */
export const TYPE = {
  stepChip: { fontFamily: FONT.latin, fontWeight: 700, fontSize: 11, lineHeight: "14px", letterSpacing: "0.8px" },
  heading: { fontFamily: FONT.arabic, fontWeight: 800, fontSize: 22, lineHeight: "26px" },
  sub: { fontFamily: FONT.arabic, fontWeight: 400, fontSize: 13, lineHeight: "21px", color: COLORS.muted },
  label: { fontFamily: FONT.arabic, fontWeight: 700, fontSize: 13, lineHeight: "16px", color: COLORS.text },
  input: { fontFamily: FONT.arabic, fontWeight: 400, fontSize: 14, lineHeight: "17px" },
  hint: { fontFamily: FONT.arabic, fontWeight: 400, fontSize: 12, lineHeight: "14px", color: COLORS.muted2 },
  error: { fontFamily: FONT.arabic, fontWeight: 400, fontSize: 12, lineHeight: "14px", color: COLORS.error },
  button: { fontFamily: FONT.arabic, fontWeight: 700, fontSize: 15, lineHeight: "18px" },
  backButton: { fontFamily: FONT.arabic, fontWeight: 700, fontSize: 13, lineHeight: "16px" },
  url: { fontFamily: FONT.latin, fontWeight: 800, fontSize: 14, lineHeight: "18px", color: COLORS.primaryHover },
  status: { fontFamily: FONT.latin, fontWeight: 400, fontSize: 12, lineHeight: "16px" },
  link: { fontFamily: FONT.arabic, fontWeight: 700, fontSize: 13, lineHeight: "16px", color: COLORS.primary },
} as const;

export const RADII = {
  input: "10px",
  card: "20px",
  pill: "100px",
  panel: "14px",
  small: "8px",
} as const;

/** Figma: [#5B2FF9 8% 0,4 blur16] + [#000 6% 0,1 blur3]. */
export const CARD_SHADOW =
  "0 4px 16px rgba(91,47,249,0.08), 0 1px 3px rgba(0,0,0,0.06)";

/** Card geometry — desktop 500w pad 32/28/28/28; mobile 436-in-460 pad 22/18/20/18. */
export const CARD = {
  width: 500,
  padding: { xs: "22px 18px 20px", md: "32px 28px 28px" },
} as const;

export const CONTROL = {
  inputHeight: 46,
  buttonHeight: 50,
  backButtonHeight: 44,
  navGap: "10px",
} as const;
